import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setOrgArchived } from '@/services/admin/set-org-archived';
import { ORGANIZATIONS_QUERY_KEY } from '@/hooks/queries/admin/use-get-organizations';

export const useSetOrgArchived = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orgId, archived }: { orgId: string; archived: boolean }) =>
      setOrgArchived(orgId, archived),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_QUERY_KEY });
    },
  });
};
